import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { OpendialogAddClubComponent } from 'app/components/dialog/open-dialog-add-club/opendialog-add-club.component';
import { ClubDetails, CodeClub } from 'app/shared/models/class/club/club';
import { FilterPopUpTable } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { Tag, TagType } from 'app/shared/models/class/tags/tag';
import { Universe } from 'app/shared/models/class/universe/universe';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UniverseService } from 'app/shared/services/universe/universe.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-admin-club-details',
  templateUrl: './admin-club-details.component.html',
  styleUrls: ['./admin-club-details.component.scss']
})
export class AdminClubDetailsComponent extends SubscriptionBaseComponent implements OnInit {
  isLoading = false;
  isCreationMode = false;
  isSessionMode = false;
  isFileMode = false;

  offerToEdit: FullOffer;
  offerPreview: FullOffer;

  imageUpdate: string;

  tab = 'offers';
  // tab = 'closedBooking';
  searchForm: UntypedFormGroup;
  tagForm: UntypedFormGroup;
  actors: CodeClub[] = [];

  displayedColumns: string[] = ['offreNom', 'clubNom', 'price', 'edit', 'isActive'];
  offers: FullOffer[];
  tagTypes: TagType[] = [];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  color: ThemePalette = 'primary';
  clubCode: any;
  club: ClubDetails;
  valueInput: any;
  valuefilterSelected: FilterPopUpTable[];
  practicePlace: PracticePlace[];
  userConnected: any;
  universes: Universe[] = [];

  offerOverViewUpdate = false;

  isLoadingClubDetails = false;

  constructor(
    private clubService: ClubService,
    private offerService: OfferService,
    private route: ActivatedRoute,
    private universeService: UniverseService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    private dataService: DataService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
    private tagService: TagService,
    private uiService: UiService
  )
  {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.initComponent();
    this.getClub();
    this.initSub();
    this.isLoading = true;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.dataService.resetPopUp();
    this.valueInput = filterValue;
    const index = this.valuefilterSelected.findIndex(v => v.column === 'search');

    if (index !== -1) {

      this.valuefilterSelected.forEach(el => {
        if (el.column === 'search') {
          el.values = [filterValue.toLowerCase()];
        }
      });
    } else {
      const label = new FilterPopUpTable('search', [filterValue]);
      this.valuefilterSelected.push(label);
    }
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);

    const index = this.valuefilterSelected.findIndex(v => v.column === 'search');
    this.valuefilterSelected.splice(index, 1);
  }

  addOffer() {
    // this.dataService.showTableOfferAdmin.next(false);
    // this.dataService.actionFormOfferAdmin.next('add');
    // this.dataService.titleAdminOffer.next('Ajouter une offre');

    // this.dataService.offerPreview.next(null);
    // this.userConnected.role === 'admin' ?
    //   this.router.navigate(['/admin/offers'], { queryParams: { clubCode: this.club.clubCode } }) :
    //   this.router.navigate(['/admin/offers']);

    this.isCreationMode = true;
    this.offerPreview = null;
  }

  editOffer({ offerKey }): void {
    this.dataService.actionFormOfferAdmin.next('edit');
    this.router.navigate(['/admin/offers'], { queryParams: { byClub: true, offerKey } });
  }

  // isActivatedOrDeactivated(offerKey: number, isActive: boolean): void {
  //   const newIsActive = !isActive;
  //   this.offerService.activateOrDeactivateOffer(offerKey, newIsActive).subscribe({
  //     next: () => this.getOffersByClub()
  //   });
  // }

  selectTab(tab: string): void {
    this.tab = tab;
  }

  getPlaceholderInputSearch(): string {
    const placeholder = {
      offers: 'Rechercher un article...',
      closedBooking: 'Rechercher un panier...',
      basket: 'Rechercher une réservation...',
    };

    return placeholder[this.tab];
  }

  goBack(): void {
    const { role } = this.authService.getDecodedToken();

    const goUrl = {
      AdminMSR: '/admin',
      admin: '/admin/actors',
      AdminCROS: '/admin',
    };

    this.router.navigate([goUrl[role]]);
  }

  openDialogUpdateClub(actionDialog: string): void {

    const dialogRef = this.dialog.open(OpendialogAddClubComponent, {
      // data: { action: actionDialog, title: titleAction, text: textValidation, btnConfirm: textBtnConfirm, club: this.club || null },
      data: { action: actionDialog, club: this.club || null },
      disableClose: true,
      height: '80%',
      width: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: () => this.getClub()
    });
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  changeOfferPreview(event: FullOffer): void {
    this.offerPreview = event;
  }

  getClub(): void {
    this.isLoadingClubDetails = true;
    this.clubService.getClubDetails().subscribe({
      next: async res => {
        this.club = await res?.find(c => c.clubCode === this.clubCode);
        await this.dataService.updateOfferPriority$.next(false);
        this.isLoadingClubDetails = false;
        await this.getOffersByClub();
        this.tagService.getTags().subscribe(types => {
          this.tagTypes = types;
        });
      }
    });
  }

  resetFields(): void {
    this.tagForm.get('tags').reset();
    this.tagForm.get('universe').reset();
  }

  openNewPage(): void {
    const url = this.tagForm.get('url').value;
    window.open(url, '_blank');
  }

  copyUrl(): void {
    const linkCopy = this.tagForm.get('url').value;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(linkCopy);
      this.uiService.showSnackbar(`Le lien a été copié avec succès.`);
    }
  }

  generateUrl(): void {
    const tagsSelected: Tag[] = this.tagForm.get('tags')?.value;
    const tagIds = tagsSelected.map(t => t.tagKey);
    const universeSelected: Universe = this.tagForm.get('universe')?.value;
    const url_generated = `${environment.urlSite}home?universe=${universeSelected?.universeKey}${this.getTagIdsText(tagIds, 'tagKey')}`;
    this.tagForm.controls['url'].setValue(url_generated);
  }

  private getTagIdsText(array: number[], param: string): string {
    let text = '';
    array?.map(id => text += `&${param}=${id}`);
    return text;
  }

  // private getOffersByClub(): void {
  //   this.offerService.getOfferByClub(this.clubCode).subscribe({
  //     next: offers => {
  //       this.offers = offers;
  //     },
  //   });
  // }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = this.route.snapshot.queryParams.clubCode || this.userConnected.club_code;
    this.universeService.getUniverse().subscribe({
      next: universes => {
        this.universes = universes;
      }
    });
    // this.clubService.getClubs().subscribe(actors => {
    //   this.actors = actors;
    // });
  }


  private initForm(): void {
    // let url = `${environment.urlSite}home`
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
    this.tagForm = this.formBuilder.group({
      tags: ['', Validators.required],
      universe: ['', Validators.required],
      url: ['', Validators.required]
    });
  }

  private initSub(): void {
    this.subscription
    .add(
      this.dataService.valueFilterPopUpSelected$.subscribe({
        next: valuefilterSelected => {
          this.valuefilterSelected = valuefilterSelected;
          this.cdr.detectChanges();
        }
      })
    )
    .add(
      this.dataService.updateOfferPriority$.subscribe({
        next: updateOfferPriority => {
          if (updateOfferPriority) {
            this.getClub();
          }
          this.cdr.detectChanges();
        }
      })
    );
  }

  onEditFinished(action?: boolean): void {
    this.offerToEdit = null;
    this.isCreationMode = false;
    this.isSessionMode = false;
    this.isFileMode = false;
    this.offerPreview = this.offers[0];

    if (action) this.getOffersByClub();
  }

  onEdit(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = true;
  }

  switchToSessionView(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = false;
    this.isSessionMode = true;
  }

  switchToFilesView(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = false;
    this.isSessionMode = false;
    this.isFileMode = true;
  }

  getOffersByClub(): void {
    this.isLoading = true;
    this.offerService.getFullOffer(this.clubCode).subscribe({
      next: async offers => {
        this.offers = await offers.sort((a, b) => b.offerKey - a.offerKey);
        this.offerPreview = this.offers[0];

        this.isLoading = false;
      },
    });
  }
}
